import React, { useEffect, useState } from "react";
import axios from "axios";
import { formatDate2,addWorkDays,formatTodayDate2 } from '../../helpers/formatted-dates';
import {  useNavigate,useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import logo from "../../../assets/images/logo.png";
import { catchError } from '../../helpers/catch-error'


const WoPrint = () => {
    const navigate = useNavigate();
    const [wo, setwo] = useState(null);
    const params = useParams()
    useEffect(() => {
        if (params?.work_order_id ) {
            getwo();
            
        }
    }, []);

 

    const getwo = async () => {

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-wo-print-by-work-order-id/"+ params?.work_order_id,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    setwo(response?.data?.wo)



                } else {
                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
                  
                }

            }).catch(function (error) {

                catchError(error,navigate)


            });


    }





    return (
        <>
      {wo &&

<table style={{fontFamily:"'Courier New', Courier, monospace",marginTop:"40px"}} width="700px" cellpadding="0" cellspacing="0" align="center" className="wo-print watermarked" >
<tr>
    <td style={{fontWeight:"bold"}} colspan="3" >
    <img src={logo} width="200" border="0" />
        <br/>

        POST OFFICE BOX 2191<br/>
        SAN LEANDRO, CA 94577<br/>
        PHONE: {process.env.REACT_APP_SUPPORT_PHONE_NUMBER}  EMAIL: Records@MedRecAps.Com<br/>
        SECURE FAX: {process.env.REACT_APP_TOLL_FREE_SUPPORT_FAX} AND {process.env.REACT_APP_SUPPORT_FAX}<br/>
        
    </td>

</tr>


<tr>
    <td colspan="2" style={{paddingTop: "20px",paddingBottom:"10px",fontWeight: "bold"}} >
        <span style={{marginRight: "30px"}}>[&nbsp;&nbsp;] Mail</span> [&nbsp;&nbsp;] Fax</td>
    <td align="right" style={{paddingTop: "40px",paddingBottom:"10px",fontWeight: "bold",width:"33%"}} >
        CASE #: {wo.work_order_no}
    </td>

</tr>



                          
                          
<tr>
    <td colspan="2" style={{fontWeight: "bold",textTransform:"uppercase"}}>
        {wo.facility_name}<br/>
        {wo.facility_attn &&
        "ATTN: "+wo.facility_attn
        }
        <br/>

{wo.facility_address}<br/>
                           {wo.facility_city+", "}
                           {wo.facility_state+" "}
                           {wo.facility_zip}<br/>



                           {wo.facility_phone &&
                              "PH: "+wo.facility_phone
                           }

                           {wo.facility_fax &&
                           " FAX: " +wo.facility_fax              
                           }
                           <br/>
    </td>

    <td align="right" style={{fontWeight: "bold"}}>
        DATE: {wo.wo_creation_date?
        formatDate2(wo.wo_creation_date)
        :
        formatTodayDate2()
        }
        <br/>
        NEEDED BY: {wo.needed_by_date?
            formatDate2(wo.needed_by_date)
            :
            formatDate2( addWorkDays(wo.wo_creation_date,10))
        }
    </td>

</tr>

<tr>

    <td colspan="3" style={{fontSize: "26px",paddingTop: "30px",paddingBottom: "30px"}} ><b>REQUEST FOR MEDICAL RECORDS ON:</b> </td>
</tr>
<tr>
    <td align="right"><b>NAME:</b></td>
    <td colspan="2" style={{fontWeight: "bold",textTransform:"capitalize"}}>
    {wo.patient_last_name.toUpperCase()+", " +wo.patient_first_name?.toUpperCase() + " " +wo.patient_middle_name?.toUpperCase() }<br/>
  </td>
</tr>
<tr>
    <td  align="right"><b>DATE OF BIRTH:</b></td>
    <td  style={{fontWeight: "bold"}}>
        {wo.patient_dob?wo.patient_dob:<i>UNKNOWN</i>}<br/>
        </td>
    <td>&nbsp;</td>

</tr>
<tr>
    <td  align="right"><b>SOC. SEC. NO:</b></td>
    <td colspan="2" style={{fontWeight: "bold"}}> 
        {wo.patient_ssn?"***-**-"+wo.patient_ssn.substring(wo.patient_ssn.length - 4):<i>UNKNOWN</i>}
    </td>
</tr>

<tr>
    <td  align="right" ><b>MED RECORD.NO:</b></td>
    <td colspan="2" style={{fontWeight: "bold"}}>
    {wo.patient_dob?wo.patient_med_rec_num:<i>NONE</i>}
      </td>


</tr>
<tr>
    <td  align="right"><b>ADMIT DATE:</b></td>
    <td colspan="2" style={{fontWeight: "bold"}}>{wo.wo_admit_date}</td>
</tr>

<tr>
    <td  align="right"><b>RECORDS NEEDED:</b></td>
    <td colspan="2" style={{fontWeight: "bold"}}>{wo.wo_order_type}</td>
</tr>

<tr>
    <td  align="right" style={{verticalAlign:"top"}}><b>SPECIAL INSTRUCTIONS:</b></td>
    <td colspan="2" style={{fontWeight: "bold"}}>
    {wo?.wo_special_instructions?.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + "<br/>" + '$2')}
      </td>
</tr>


<tr>
    <td colspan="3" style={{textAlign: "justify"}}><br/><br/>ATTACHED IS A REQUEST FOR MEDICAL RECORDS IN YOUR POSSESSION AS SPECIFIED ABOVE. PLEASE PROVIDE SIGNIFICANT ASPECTS OF THE RECORDS INCLUDING AND NOT LIMITED TO CLINICAL HISTORY, LABS, X-RAYS, PATHOLOGY REPORTS, EKG AND ECG REPORTS, CONSULTS AND HOSPITALIZATION RECORDS IF ANY.<br/><br/></td>

</tr>
<tr>
    <td colspan="3"><b>WE ASK THAT YOU FULFIL THIS REQUEST BY DOING ANY OF THE FOLLOWING:</b><br/><br/></td>

</tr>


<tr>
    <td colspan="3">  
        <ol type="a" style={{fontWeight: "bold"}}>              
            <li> Uploading to: {process.env.REACT_APP_APP_URL}/upload-record</li>
            <li> By Emailing to Records@MedRecAps.Com </li>
            <li> Faxing Records to Our Secure Fax at {process.env.REACT_APP_SUPPORT_FAX}</li>
        </ol>  
    </td>

</tr>
<tr>
    <td colspan="3"> IF THERE IS A FEE FOR THIS PLEASE CALL FOR PRIOR APPROVAL AND PAYMENT <b>AS MEDREC APS, LLC DO NOT HONOR INVOICES FROM FACILITIES AND OR THIRD PARTIES WITHOUT PRIOR APPROVAL.</b><br/><br/></td>

</tr>



<tr>
    <td colspan="2" ><b>SINCERELY,</b><br/><br/><br/></td>
     <td  rowspan="2"> <img src={logo} width="200" border="0"  /></td>

</tr>
<tr>
    <td colspan="2" ><b>MEDREC APS, LLC</b><br/></td>

</tr>

<tr>
    <td colspan="4" align="center" >
<br/>
<b>REPRODUCTIVE HEALTH PRIVACY (89 FR 32976) ATTESTATION</b>
    <br/>
That this request for records is permitted under <b>45 CFR 164.506</b> of the HIPAA Privacy Rule and not associated with ANY Legal Investigative or Health Oversight or Enforcement Activity and the FINAL Rule Protecting Reproductive Health Care Information <b>(89 FR 32976) DOES NOT APPLY TO THIS REQUEST NOR IS AN ATTESTATION REQUIRED.</b>


    </td>

</tr>



</table>

      

                             }
                               
                             </>
    )

}
export default WoPrint;